import React, { ReactNode, useCallback } from 'react';
import { DrawerProps as AntDrawerProps } from 'antd-v5';
import { Disclosure } from 'components/Dialog';
import { SAntDrawer } from 'UI/Drawer/Drawer.styled';
import { useOffsetTop } from 'utils/hooks/useOffsetTop';

interface DrawerProps {
  children: ReactNode;
  title: string;
  footer?: ReactNode;
  handleClose?: () => void;
  disclosure: Disclosure;
  placement?: AntDrawerProps['placement'];
  // Bind the drawer to a parent element (or `false` to render in place) instead of the viewport.
  getContainer?: AntDrawerProps['getContainer'];
  width?: number | string;
}

export const Drawer = ({
  children,
  title,
  disclosure,
  handleClose,
  footer,
  placement = 'right',
  getContainer,
  width = 378,
}: DrawerProps) => {
  const { isOpen, onClose } = disclosure;
  const offsetTop = useOffsetTop('HOME_PAGE');
  const isContained = getContainer !== undefined;

  const handleOnClose = useCallback(() => {
    if (handleClose) {
      handleClose();
    }
    onClose();
  }, [handleClose, onClose]);

  return (
    <SAntDrawer
      title={title}
      footer={footer}
      onClose={handleOnClose}
      open={isOpen}
      placement={placement}
      width={width}
      getContainer={getContainer}
      offsetTop={offsetTop}
      $contained={isContained}
      $width={width}
      styles={{
        mask: {
          backgroundColor: 'transparent',
        },
        wrapper: {
          boxShadow: isContained ? '2px 0 8px rgba(0, 0, 0, 0.2)' : 'none',
        },
      }}
    >
      {children}
    </SAntDrawer>
  );
};
